import { useState, useEffect } from "react";
import validator from "validator";
import { format } from "date-fns";
import { getGeneralTypes, postData, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, divOverflowHidden, divFloatLeft, divFloatRight, StyledSelectLeft, StyledSelectRight } from "./Style";
import { useMsal } from "@azure/msal-react";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';

import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from "./ConfirmDialog";

const PersonnelChangeForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [RateText, setRateText] = useState('');
  const [errorRequest, setErrorRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [RequestType, setRequestType] = useState([]);
  const [selectedRequestType, setSelectedRequestType] = useState("");
  const [PhoneType, setPhoneType] = useState([]);
  const [selectedPhoneType, setSelectedPhoneType] = useState("");
  const [OccupationType, setOccupationType] = useState([]);
  const [selectedOccupationType, setSelectedOccupationType] = useState("");
  const [RateType, setRateType] = useState([]);
  const [selectedRateType, setSelectedRateType] = useState("");
  const [RequestDateVal, SetRequestDateVal] = useState(new Date());
  const [EffectiveDateVal, SetEffectiveDateVal] = useState(new Date());

  const [userEmail, setUserEmail] = useState('');

  const [requestReasonVal, setRequestReason] = useState('');

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isValid, setIsValid] = useState(false);

  const { instance } = useMsal();
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl, setDialogDestUrl] = useState("");




  useEffect(() => {
    async function fetchInitialData(_email) {
      //Matter ID dropdown
      const currentAccount = instance.getActiveAccount();
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username);
        body.email = currentAccount.username;
      }
      const tokenRequest = {
        account: currentAccount, // This is an example - Select account based on your app's requirements
        scopes: ["User.Read"]
      }

      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);

      //Request Type dropdown
      const RequestTypeResponse = await getGeneralTypes('/Settings/RequestTypes');
      const filteredData = RequestTypeResponse.filter((data) => data.Value.HasPersonnel === true);
      RequestTypeResponse.errors ? setErrorRequest(true) : setRequestType(filteredData);
      //Phone Type
      const PhoneTypeResponse = await getGeneralTypes('/Settings/PhoneTypes');
      PhoneTypeResponse.errors ? setErrorRequest(true) : setPhoneType(PhoneTypeResponse);
      //Occupation Type
      const OccupationTypeResponse = await getGeneralTypes('/Settings/OccupationTypes');
      OccupationTypeResponse.errors ? setErrorRequest(true) : setOccupationType(OccupationTypeResponse);
      //Rate Type
      const RateTypeResponse = await getGeneralTypes('/Settings/RateTypes');
      RateTypeResponse.errors ? setErrorRequest(true) : setRateType(RateTypeResponse);

      SetRequestDateVal(new Date);
      SetEffectiveDateVal(new Date);

    }

    fetchInitialData();
  }, [instance, userEmail]);


  //Handler MatterID
  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);
  };
  //Handler RequestType
  const handleSelectRequestType = (event) => {
    setSelectedRequestType(event.target.value);
  };

  //Handler PhoneType
  const handleSelectPhoneType = (event) => {
    setSelectedPhoneType(event.target.value);
  };
  //Handler OccupationType
  const handleSelectOccupationType = (event) => {
    setSelectedOccupationType(event.target.value);
  };
  //Handler RateType
  const handleSelectRateType = (event) => {
    setSelectedRateType(event.target.value);
  };


  async function handleSubmit(e) {
    /*
    const errors = validateData();
    if(Object.keys(errors).length)
    {
        setErrors(errors);
        return;
    }

    setErrors({});
    */

    e.preventDefault();
    setUploading(true);

    // Read the form data
    const form = e.target;
    const formData = new FormData(form);

    const formJson = Object.fromEntries(formData.entries());


    let _ctype = "PersonnelChange";
    let _mID = formJson.MatterIDSelect;
    let _notes = formJson.txtRequestReason;


    let _personnel = {
      "Prefix": formJson.txtPrefix,
      "FirstName": formJson.txtFN,
      "MiddleName": formJson.txtMN,
      "LastName": formJson.txtLN,
      "Suffix": formJson.txtSuffix,
      "Intials": "No initials exist",
      "CompanyName": formJson.txtCN,
      "TaxID": formJson.txtFTID,
      "Email": formJson.txtEmail,
      "PhoneNumber": formJson.txtPhone,
      "PhoneType": formJson.PhoneTypeSelect,
      "Type": formJson.OccupationTypeSelect,
      "EffectiveDate": format(EffectiveDateVal.$d, "MM/dd/yyyy"),
      "Rate": parseFloat(formJson.txtRate).toFixed(2),
      "RateType": formJson.RateTypeSelect

    }


    let postObject = {
      EMail: userEmail,
      MatterID: _mID,
      RequestType: _ctype,
      DateOfRequest: format(RequestDateVal.$d, "MM/dd/yyyy"),
      ReasonForRequest: _notes,
      Personnel: _personnel
    };

    postDataResponse('/Matter/RequestForPersonnelChange', postObject).then((response) => {
      setUploading(false);
      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        SetDialogMessage("Personnel Change was Successfully Submitted");
      }
      else {
        setIsSuccess(false);
        SetDialogMessage(response.response.data.detail);
      }
      setOpenDialog(true);
    });

    /*let response = await postDataResponse('/Matter/RequestForPersonnelChange', postObject);

    if (response.status === 200 || response.status === 201) {
      setIsSubmitted(true);

      navigate('/Success?message=Personnel Change Successfully sent to Pro Law');
    }*/
  };

  const handleCloseDialog = () => { setOpenDialog(false); };


  return (
    <form method="post" onSubmit={handleSubmit}>
      <div>
        <Card className="form-card">
          <CardHeader title="Request for Personnel Change" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    name="MatterIDSelect"
                    value={selectedValueMatterID}
                    label="Matter ID"
                    onChange={handleSelectChangeMatterID}
                    required
                  >
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {MatterID !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth margin="normal">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {/*
                    (<DatePicker name="RequestDate"   id="RequestDate"   label="Date of Request"  value={dayjs(RequestDateVal)} onChange={(newValue) => { SetRequestDateVal(newValue); setIsValid(true); }} required />}
                    */}
                    <DatePicker name="RequestDate" id="RequestDate" label="Date of Request" onChange={(newValue) => { SetRequestDateVal(newValue); setIsValid(true); }} value={dayjs('RequestDateVal')} defaultValue={new Date()} required />
                  </LocalizationProvider>
                </FormControl>
              </Grid>

              <Grid item xs={3}>

              </Grid>
              {/*<Grid item xs={8}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="TypeLbl">Request Type</InputLabel>
                  <Select
                    name="RequestTypeSelect"
                    id="RequestTypeSelect"
                    label="Request Type"
                    value={selectedRequestType}
                    onChange={handleSelectRequestType}
                    required>
                    {RequestType.map((value) => (
                      <MenuItem key={value.Key} value={value.Key}>
                        {value.Value.Description}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>*/}
              <Grid item xs={12}>
                <TextField
                  name="txtRequestReason"
                  label="Reason for Request" variant="outlined" margin="normal"
                  multiline
                  rows={2}
                  maxRows={5}
                  value={requestReasonVal}
                  onChange={e => setRequestReason(e.target.value)}
                  required
                  fullWidth
                  placeholder="Reason for Request"

                />

              </Grid>

              <Grid item xs={6}>
                <TextField name="txtCN" id="txtCN" label="Company Name" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={6}>
                <TextField name="txtFTID" id="txtFTID" label="Federal Tax ID" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={1}>
                <TextField name="txtPrefix" id="txtPrefix" label="Prefix" variant="outlined" margin="normal" fullWidth />
              </Grid>
              <Grid item xs={4}>
                <TextField name="txtFN" id="txtFN" label="First Name" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={2}>
                <TextField name="txtMN" id="txtMN" label="Middle Name" variant="outlined" margin="normal" fullWidth />
              </Grid>
              <Grid item xs={4}>
                <TextField name="txtLN" id="txtLN" label="Last Name" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={1}>
                <TextField name="txtSuffix" id="txtSuffix" label="Suffix" variant="outlined" margin="normal" fullWidth />
              </Grid>

              <Grid item xs={6}>
                <TextField name="txtEmail" id="txtEmail" label="Email" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={3}>
                <TextField name="txtPhone" id="txtPhone" label="Phone" variant="outlined" margin="normal" fullWidth required />
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="PhoneTypeLbl">Type</InputLabel>
                  <Select
                    name="PhoneTypeSelect"
                    id="PhoneTypeSelect"
                    label="PhoneTypeLbl"
                    required
                    value={selectedPhoneType}
                    onChange={handleSelectPhoneType}>
                    {PhoneType.map((value) => (
                      <MenuItem key={value.Key} value={value.Key}>
                        {value.Value}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}><FormControl fullWidth margin="normal">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker name="EffectiveDate" id="EffectiveDate" label="Proposed Start Date" onChange={(newValue) => { SetEffectiveDateVal(newValue); setIsValid(true); }} value={dayjs('EffectiveDateVal')} defaultValue={new Date()} />
                </LocalizationProvider></FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl fullWidth margin="normal"><StyledSelect value={selectedOccupationType}
                  name="OccupationTypeSelect"
                  onChange={handleSelectOccupationType} >
                  {OccupationType.map((value) => (
                    <option key={value.Key} value={value.Key}>
                      {value.Value}
                    </option>
                  ))}

                </StyledSelect></FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  error={isNaN(parseFloat(RateText))}
                  name="txtRate"
                  id="txtRate"
                  label="Rate"
                  helperText={isNaN(parseFloat(RateText)) ? 'Please enter a valid rate' : ''}
                  onChange={(e) => setRateText(e.target.value)}
                  value={RateText}
                  variant="outlined" margin="normal" fullWidth required
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl fullWidth margin="normal"><StyledSelect value={selectedRateType}
                  name="RateTypeSelect"
                  onChange={handleSelectRateType} >
                  {RateType.map((value) => (
                    <option key={value.Key} value={value.Key}>
                      {value.Value}
                    </option>
                  ))}

                </StyledSelect></FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
              </Grid>


              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} fullWidth>Submit</Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} value="Reset" fullWidth>Clear</Button>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
        <ConfirmDialog
          isOpen={openDialog}
          onClose={handleCloseDialog}
          isSuccess={isSuccess}
          message={dialogMessage}
          destination={dialogDestUrl}
        />
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      {/*
      <div>
        <HeaderContainer>
          <Typography sx={{ flexGrow: 1 }}>
            <HeaderText><Typography variant="h6">Request For Personnel Change</Typography></HeaderText>
          </Typography>
        </HeaderContainer>
        <InputContainer>
          <InputWrapper>
            <div>
              <label>Matter ID</label>
            </div>
            <div>

              <StyledSelect
                name="MatterIDSelect"
                value={selectedValueMatterID}
                onChange={handleSelectChangeMatterID}
                autoFocus
              >

                {MatterID !== null ? MatterID.map((value) => (
                  <option key={value.id} value={value.id}>
                    {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                  </option>
                )) : <option></option>}
              </StyledSelect>

            </div>
            <table>
              <tr>
                <td> <div>
                  <label>Date of Request</label>
                </div></td>
                <td> <div>
                  <label>Type</label>
                </div></td>
              </tr>
              <tr>
                <td>
                  <div>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker name="RequestDate" id="RequestDate" onChange={(newValue) => { SetRequestDateVal(newValue); setIsValid(true); }} value={dayjs('RequestDateVal')} defaultValue={new Date()} />
                    </LocalizationProvider>



                  </div>
                </td>
                <td> <div >

                  <StyledSelect value={selectedRequestType}
                    name="RequestTypeSelect"
                    onChange={handleSelectRequestType} >
                    {RequestType.map((value) => (
                      <option key={value.Key} value={value.Key}>
                        {value.Value.Description}
                      </option>
                    ))}

                  </StyledSelect>
                </div></td>
              </tr>
            </table>



            <div>
              <label>Reason for Request</label>
            </div>

            <div>
              <textarea
                name="txtRequestReason"
                rows={5}
                cols={115}
                value={requestReasonVal}
                onChange={e => setRequestReason(e.target.value)}
                required

              />
            </div>

            <div>
              <table>
                <tr>
                  <td>
                    <div>
                      <TextField
                        name="txtPrefix"
                        id="txtPrefix"
                        label="Prefix"
                        variant="outlined"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtFN"
                        id="txtFN"
                        label="First Name"
                        variant="outlined"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtMN"
                        id="txtMN"
                        label="Middle Name"
                        variant="outlined"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtLN"
                        id="txtLN"
                        label="Last Name"
                        variant="outlined"

                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtSuffix"
                        id="txtSuffix"
                        label="Suffix"
                      />
                    </div>
                  </td>
                </tr>


              </table>
            </div>




            <div>
              <table>
                <tr>
                  <td>
                    <div>
                      <TextField
                        style={{ width: 150 }}
                        name="txtEmail"
                        id="txtEmail"
                        label="Email"
                        variant="outlined"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtPhone"
                        id="txtPhone"
                        label="Phone"
                        variant="outlined"
                        style={{ width: 250 }}
                      />
                    </div>
                  </td>
                  <td>
                    <div >

                      <StyledSelect value={selectedPhoneType}
                        name="PhoneTypeSelect"
                        onChange={handleSelectPhoneType} >
                        {PhoneType.map((value) => (
                          <option key={value.Key} value={value.Key}>
                            {value.Value}
                          </option>
                        ))}

                      </StyledSelect>
                    </div>
                  </td>

                </tr>


              </table>
            </div>





            <div>
              <table>
                <tr>
                  <td>
                    <div>
                      <TextField
                        style={{ width: 150 }}
                        name="txtCN"
                        id="txtCN"
                        label="Company Name"
                        variant="outlined"
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <TextField
                        name="txtFTID"
                        id="txtFTID"
                        label="Federal Tax ID"
                        variant="outlined"
                        style={{ width: 250 }}
                      />
                    </div>
                  </td>

                </tr>


              </table>
            </div>


            <div>
              <table>
                <tr>
                  <td>
                    <div>
                      <StyledSelect value={selectedOccupationType}
                        name="OccupationTypeSelect"
                        onChange={handleSelectOccupationType} >
                        {OccupationType.map((value) => (
                          <option key={value.Key} value={value.Key}>
                            {value.Value}
                          </option>
                        ))}

                      </StyledSelect>
                    </div>
                  </td>
                  <td>




                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker name="EffectiveDate" id="EffectiveDate" onChange={(newValue) => { SetEffectiveDateVal(newValue); setIsValid(true); }} value={dayjs('EffectiveDateVal')} defaultValue={new Date()} />
                      </LocalizationProvider>
                    </div>
                  </td>

                </tr>


              </table>
            </div>


            <div>
              <table>
                <tr>
                  <td>
                    <div>


                      <TextField
                        error={!(/^\d+$/.test(RateText))}
                        name="txtRate"
                        id="txtRate"
                        label="Rate"
                        helperText={!(/^\d+$/.test(RateText)) ? 'Should be a whole number.' : ''}
                        onChange={(e) => setRateText(e.target.value)}
                        value={RateText}

                      />
                    </div>
                  </td>
                  <td>




                    <div>
                      <StyledSelect value={selectedRateType}
                        name="RateTypeSelect"
                        onChange={handleSelectRateType} >
                        {RateType.map((value) => (
                          <option key={value.Key} value={value.Key}>
                            {value.Value}
                          </option>
                        ))}

                      </StyledSelect>
                    </div>
                  </td>

                </tr>


              </table>
            </div>

            <RightJustifyDiv>
              {isValid && <GreyButton type="submit">Submit</GreyButton>}&nbsp; &nbsp;
              <RedButton type="reset" onClick={(e) => { e.preventDefault(); SetRequestDateVal(new Date()); setIsValid(false); setRequestReason(''); setIsSubmitted(false); }} >Clear</RedButton>
            </RightJustifyDiv>

            <RightJustifyDiv>
              {isSubmitted ? <SubmitSpan>Submitted Successfully!</SubmitSpan> : <span></span>}
            </RightJustifyDiv>
          </InputWrapper>


        </InputContainer>
      </div>*/}

    </form>
  );
};
export default PersonnelChangeForm;

